export const BEFORE_LOGIN = "BEFORE_LOGIN";
export const SET_TOKEN = "SET_TOKEN";
export const SET_CORDIVARI_ID = "SET_CORDIVARI_ID";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_IS_ADMIN = "SET_IS_ADMIN";
export const SET_IS_DEBUG = "SET_IS_DEBUG";
export const SET_IS_UNILAB = "SET_IS_UNILAB";
export const CLEAR_TOKEN = "CLEAR_TOKEN";
export const SHOW_TRANSLATION_ID = "SHOW_TRANSLATION_ID";
export const SHOW_ENGLISH_TOOLTIP = "SHOW_ENGLISH_TOOLTIP";
